module.exports = __webpack_public_path__ + "img/sort-icon-2.2353ddaf.png";